var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Thank You! Your response has been recorded!")]),_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("Back to form")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }